import React from 'react';

import EventIcon from '../../../../../../core/gd-components/icons/event/event-icon'
import InfoPanelRow from "../../../../../../core/gd-ui/ip-section-row/info-panel-row";
import FieldFormElement from "../../../../../fields3/render/form-elemnent";
import FormModel from "../../../../../gd-form/common/form-model-manager";
import UserAssignment_Fields from "../../../model/fields";
import FormFieldError from "../../../../../gd-form/common/form-error/form-field-error";
import Event from "../../../../../model2/event/event";
import FormRowFlex from "../../../../../gd-form/form/form-flex/row";


type Props = {
    form        : FormModel
    userOptions : Options
    events      : Event[] | null
}

export default class ReassignUserEvents extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    renderEventsList = () => {

        const eventsReassignToField = new UserAssignment_Fields().eventsReassignUserId

        eventsReassignToField.options = this.props.userOptions

        return (
            <>
                {!_.isEmpty(this.props.events) && (
                    <div className="ui5-list m-t-10 m-l-25">
                        {
                            _.map(this.props.events, (event, key) => {
                                const eventModel = new Event(event, {parse: true});
                                return (
                                    <div key={key} className="row">
                                        <div className="cell h-40 p-0">
                                            <EventIcon className="ui5-ico-14 m-r-10" event={eventModel} hint={false}/>
                                            <div className="ui5-txt-default max-w-300">{event.name}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )}

                <FormRowFlex label="Re-assign to" width={140} className="m-t-15 p-l-25">
                    <div className="flex-column-left-top">
                        <FieldFormElement field={eventsReassignToField} form={this.props.form}
                                          className="w-300"/>
                        <FormFieldError form={this.props.form} field={eventsReassignToField}/>
                    </div>
                </FormRowFlex>
            </>
    )
    }

    render() {
        if (!this.props.events || this.props.events.length < 1) return false;

        return (
            <>
                <div className="ui5-txt-default txt-bold m-t-20 m-l-25">Events</div>
                {this.renderEventsList()}
            </>
        )
    }
}
